import React, { FC, ReactNode, useState } from "react"

import { blogConfig } from "config"

import {
  IconCheck,
  IconCopyLink,
  IconFacebook,
  IconLinkedIn,
  IconTwitter,
} from "components/core/Icons"

import * as S from "./StayInTheLoop.styles"
import { SubscribeForm } from "./SubscribeForm"

interface StayInTheLoopProps {
  title?: string
  text?: ReactNode
  canonical?: string
  hasSocial?: boolean
  isOwner?: boolean
  source?: string
}

export const StayInTheLoop: FC<StayInTheLoopProps> = ({
  canonical = "/",
  title = "Stay in the loop",
  text = (
    <>
      Don’t forget to subscribe to our mailing list to get notified about the
      latest stories. Oh, and get <strong>$100</strong> off your first stay with
      us.
    </>
  ),
  hasSocial,
  isOwner,
  source,
}) => {
  const [copyLinkTimeout, setCopyLinkTimeout] = useState<number>()

  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(canonical)

    window.clearTimeout(copyLinkTimeout)
    setCopyLinkTimeout(
      window.setTimeout(() => {
        setCopyLinkTimeout(undefined)
      }, 3000)
    )
  }

  return (
    <S.Container>
      <S.Subcontainer>
        <S.Title>{title}</S.Title>
        {hasSocial && (
          <S.SocialMedia>
            <S.LinkItem
              href={`https://twitter.com/intent/tweet?url=${canonical}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <IconTwitter />
            </S.LinkItem>
            <S.LinkItem
              href={`https://www.facebook.com/dialog/feed?app_id=${blogConfig.integrations.facebookAppId}&redirect_uri=${canonical}&display=page&link=${canonical}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <IconFacebook />
            </S.LinkItem>
            <S.LinkItem
              href={`https://www.linkedin.com/shareArticle?url=${canonical}&mini=true`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <IconLinkedIn />
            </S.LinkItem>
            <S.LinkItemButton
              disabled={!!copyLinkTimeout}
              onClick={handleCopyClick}
            >
              {copyLinkTimeout ? <IconCheck /> : <IconCopyLink />}
            </S.LinkItemButton>
          </S.SocialMedia>
        )}
        <S.Text>{text}</S.Text>
        <SubscribeForm isOwner={isOwner} source={source} />
      </S.Subcontainer>
    </S.Container>
  )
}
